export default "https://d1e6s5z4lzmgxx.cloudfront.net/9448f7a6-2ffc-48da-926d-72a27a448f00/images/notes-icon.svg?4dd3c9de2b63bbe42664f7d78570473a";